
<div class="d-md-flex align-items-center bg-white p-2" *ngIf="Editable">
  <div class="ml-auto mt-3 mt-md-0" >
    <button type="button" (click)="Add()" *ngIf="HasAddButton && permission.isPermitted('gestione-prodotti')" class="btn btn-cyan rounded-pill p-2" >
      <i class="fas fa-plus  font-14 mr-1 text-white"></i>
      <span class="ml-1 text-white font-weight-bold">Aggiungi</span>
    </button>
  </div>
</div>
<div class="table-responsive">
  <table class="table bg-white table-hover align-middle mb-0 no-wrap">
    <thead>
    <tr>
      <th></th>
      <th>Prodotto</th>
      <th scope="col" *ngIf="permission.isPermitted('gestione-prodotti') && Editable">Azioni</th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let Prodotto of items">
      <td>
        <span class="text-dark font-medium font-16">
          <span class="badge badge-light text-dark rounded-pill font-16 mr-1">
            <i-feather name="info" class="feather-sm"></i-feather>
          </span>
          <img src="{{apiPaths.getBaseAPI()}}/file/image/{{Prodotto.id_immagine}}" class=" border p-1" width="150">
        </span>
      </td>
      <td>
        <span class="text-dark font-medium font-16">
          <span class="badge badge-light text-dark rounded-pill font-16 mr-1">
            <i-feather name="info" class="feather-sm"></i-feather>
          </span>
          {{ Prodotto.prodotto}}
        </span>
      </td>
      <td class="align-middle" *ngIf="permission.isPermitted('gestione-prodotti') && Editable">
        <a *ngIf="HasDeleteButton"  href="javascript:void(0)" class="link text-danger font-16 font-weight-bold" (click)='Delete(Prodotto)'>
          <i-feather name="trash-2" class="feather-sm"></i-feather>
        </a>
      </td>
    </tr>
    </tbody>
  </table>
</div>
